import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";

import TasksAdmin from "./TasksAdmin";
import PathwaysScenariosAdmin from "./PathwaysScenariosAdmin";
import GameslogAdmin from "./GameslogAdmin";
import DefinedScenariosAdmin from "./DefinedScenariosAdmin";
import TradeoffIndicatorsAdmin from "./TradeoffIndicatorsAdmin";
import Usuarios from "./Usuarios";

const ADMIN_SCENATHON_TAB_KEY = "admin_scenathon_active_tab_v1";
const ALLOWED_TABS = new Set([
  "tasks",
  "users",
  "data",
  "gameslog",
  "definedscenarios",
  "tradeoff-indicators",
]);

const TabButton = ({ label, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={`px-6 py-3 font-medium text-sm border-b-2 transition whitespace-nowrap ${
      isActive
        ? "border-green-600 text-green-600"
        : "border-transparent text-gray-600 hover:text-gray-900"
    }`}
  >
    {label}
  </button>
);

export default function AdminScenathon() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState(() => {
    try {
      const saved = localStorage.getItem(ADMIN_SCENATHON_TAB_KEY);
      return saved && ALLOWED_TABS.has(saved) ? saved : "tasks";
    } catch {
      return "list";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(ADMIN_SCENATHON_TAB_KEY, activeTab);
    } catch {
      // ignore storage errors
    }
  }, [activeTab]);

  // Solo admins (type_id = 1) pueden acceder
  if (!user || user.type_id !== 1) {
    return (
      <div className="w-full p-6 font-montserrat">
        <div className="max-w-2xl mx-auto">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6">
            <h2 className="text-red-800 font-bold text-lg mb-2">Access Denied</h2>
            <p className="text-red-700">
              Only administrators can access this section. If you believe this is an error, please contact an administrator.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full font-montserrat">
        <div className="w-full mx-auto">
          {/* Tabs */}
          <div className="mt-10 bg-white border-b border-gray-200 rounded-t-lg">
            <div className="flex overflow-x-auto">
              <TabButton
                label="Tasks"
                isActive={activeTab === "tasks"}
                onClick={() => setActiveTab("tasks")}
              />
              <TabButton
                label="Users"
                isActive={activeTab === "users"}
                onClick={() => setActiveTab("users")}
              />
              <TabButton
                label="Pathways & Scenarios"
                isActive={activeTab === "data"}
                onClick={() => setActiveTab("data")}
              />
              <TabButton
                label="Games Log"
                isActive={activeTab === "gameslog"}
                onClick={() => setActiveTab("gameslog")}
              />
              <TabButton
                label="Defined Scenarios"
                isActive={activeTab === "definedscenarios"}
                onClick={() => setActiveTab("definedscenarios")}
              />
              <TabButton
                label="Tradeoff Indicators"
                isActive={activeTab === "tradeoff-indicators"}
                onClick={() => setActiveTab("tradeoff-indicators")}
              />
            </div>
          </div>

          {/* Content */}
          <div className="bg-white rounded-b-lg">
            {activeTab === "tasks" && <TasksAdmin />}
            {activeTab === "users" && <Usuarios />}
            {activeTab === "data" && <PathwaysScenariosAdmin />}
            {activeTab === "gameslog" && <GameslogAdmin />}
            {activeTab === "definedscenarios" && <DefinedScenariosAdmin />}
            {activeTab === "tradeoff-indicators" && <TradeoffIndicatorsAdmin />}
          </div>
        </div>
    </div>
  );
}
